"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _components2 = require("components");

var _emails = require("../utils/mappings/emails");

var _FormLink = require("./forms/FormLink");

var _FormLink2 = _interopRequireDefault(_FormLink);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCommunicationTexts = function getCommunicationTexts(email) {
    var emailLink = _react2.default.createElement(
        _FormLink2.default,
        { link: "mailto:" + email },
        email
    );

    return {
        contactPrompt: {
            agentCustomer: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "dynamicCommunication.contactPromptText.agentCustomer",
                defaultMessage: "contact your travel agent" }),
            directCustomer: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "dynamicCommunication.contactPromptText.directCustomer",
                defaultMessage: "{contactUs}",
                values: {
                    contactUs: _react2.default.createElement(
                        "a",
                        { target: "_blank", href: "/contact-us" },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "dynamicCommunication.contactPromptText.directCustomer.contactUs",
                            defaultMessage: "contact us" })
                    )
                } }),
            agent: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "dynamicCommunication.contactPromptText.agentStaff",
                defaultMessage: "contact G Adventures" })
        },
        voucherEmail: {
            agentCustomer: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "dynamicCommunication.voucherEmailText.agent",
                defaultMessage: "After all travellers on this booking are Good to Go, contact your travel agent to retrieve your vouchers." }),
            directCustomer: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "dynamicCommunication.voucherEmailText.direct",
                defaultMessage: "After all travellers on this booking are Good to Go, vouchers can be accessed within your {GAccount}.",
                values: {
                    GAccount: _react2.default.createElement(
                        "a",
                        { target: "_blank", href: "https://www.gadventures.com/profiles" },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "dynamicCommunication.voucherEmailText.direct.GAccount",
                            defaultMessage: "G Account" })
                    ),
                    GMobile: _react2.default.createElement(
                        "a",
                        { target: "_blank", href: "https://www.gadventures.com/mobile/" },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "dynamicCommunication.voucherEmailText.direct.GMobile",
                            defaultMessage: "G Adventures Mobile App" })
                    )
                } })
        },
        contactPromptWithEmail: {
            agentCustomer: emailLink,
            directCustomer: emailLink,
            agent: emailLink,
            staff: emailLink
        }
    };
};

var determineTargetUser = function determineTargetUser(bookingMeta, isCustomerUser) {
    var isDirect = bookingMeta.sales_channel.who === "Direct";

    return isDirect ? isCustomerUser ? "directCustomer" : "staff" : isCustomerUser ? "agentCustomer" : "agent";
};

var CommunicationText = function CommunicationText(_ref) {
    var email = _ref.email,
        bookingMeta = _ref.bookingMeta,
        isCustomerUser = _ref.isCustomerUser,
        type = _ref.type;

    var communicationTextMap = getCommunicationTexts(email);

    var message = communicationTextMap[type][determineTargetUser(bookingMeta, isCustomerUser)];
    if (!message) return _react2.default.createElement(
        "a",
        { target: "_blank", href: "/contact-us" },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: "dynamicCommunication.contactPromptText.directCustomer.contactUs",
            defaultMessage: "contact us" })
    );

    return message;
};

var DynamicCommunication = function DynamicCommunication(_ref2) {
    var currentUser = _ref2.currentUser,
        type = _ref2.type,
        booking = _ref2.booking,
        bookingMetaCall = _ref2.bookingMetaCall,
        bookingMeta = _ref2.bookingMeta;

    var bookingCompanyId = _lodash2.default.get(booking, "booking_company.id", 1);
    var email = _emails.EMAIL_MAP[bookingCompanyId] || _emails.EMAIL_MAP[1];

    var natGeoAgencyId = _lodash2.default.get(booking, "agency.id", null);
    if (natGeoAgencyId && _emails.AGENCY_EMAIL_MAP[natGeoAgencyId]) email = _emails.AGENCY_EMAIL_MAP[natGeoAgencyId];

    return _react2.default.createElement(
        _components2.LoadingIndicator,
        { inline: true, apiCalls: [bookingMetaCall] },
        _react2.default.createElement(CommunicationText, { email: email, isCustomerUser: !!currentUser, type: type, bookingMeta: bookingMeta })
    );
};

DynamicCommunication.propTypes = {
    type: _propTypes2.default.string.isRequired,
    booking: _propTypes2.default.object.isRequired,
    bookingMetaCall: _propTypes2.default.object.isRequired,
    bookingMeta: _propTypes2.default.object.isRequired,
    currentUser: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        booking: state.booking,
        bookingMetaCall: state.apiCalls.bookingMetaData,
        bookingMeta: state.bookingMeta,
        currentUser: "" + state.user.customerId || ""
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DynamicCommunication);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/DynamicCommunication.js
// module id = 1296
// module chunks = 0